<template>
  <div class="user-center__layout">
    <app-header />
    <div class="user-center__layout__content">
      <div class="user-center__layout__sidebar">
        <sidebar />
      </div>
      <div
        :class="[
          'user-center__layout__main'
        ]"
      >
        <div class="router-view__wrap">
          <router-view />
          <app-footer v-if="!noFooter"></app-footer>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import AppHeader from 'components/app/app-header'
import AppFooter from 'components/app/app-footer'
import sidebar from './sidebar'
import { computed } from 'vue'
import { useRoute } from 'vue-router'
const route = useRoute()

const noFooterPath = ['images']
const noFooter = computed(() => noFooterPath.includes(route.name))
</script>

<style lang="scss" scoped>
@import '@/styles/common.scss';
.user-center__layout {
  width: 100%;
  min-width: 1330px;
  height: 100%;
  &__content {
    // width: 100%;
    // min-height: calc(100vh - $header-height);
    // background-color: var(--color-bg-2);
    // display: flex;
    // &.noFooter {
    //   min-height: calc(100vh - $header-height);
    // }
    width: 100%;
    min-height: calc(100vh - $header-height);
    background-color: var(--color-bg-2);
    display: flex;
  }
  &__main {
    flex: 1;
    width: 1px;
    .router-view__wrap {
      // height: calc(100vh - 116px);
      overflow-y: auto;
      height: calc(100vh - 56px);
      overflow-x: hidden;
    }
    position: relative;
    box-sizing: border-box;
    &.sidebar {
      margin-left: 60px;
      min-width: 1270px;
    }
  }
  &__sidebar {
    background-color: var(--color-bg-1);
    box-shadow: 0 4px 35px 0 var(--color-bg-2);
    // position: fixed;
    position: relative;
    top: 0;
    left: 0;
    bottom: -60px;
    // width: 60px;
    z-index: 10;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    // &:hover {
    //   width: 180px;
    // }
  }
}
</style>
